<template>
  <div>
    <tree :feature-action-data="feature_action_data" />
  </div>
</template>

<script>
import Unauthorised from 'VuePartials/App/Unauthorised.vue';
import Tree from 'VuePartials/App/Preferences/Permissions/Tree';

// Misc
Vue.component('unauthorised', Unauthorised);
Vue.component('tree', Tree);

export default {
  name: 'Preferences',
  components: {
    Tree,
  },
  data: () => ({
    feature_action_data: {},
    user: window.user,
  }),
  async mounted() {
    try {
      const { data: { data, success } } = await axios.get(`/permissions/${window.user.uuid}/show`);
      if (success) {
        this.feature_action_data = data;
      }
    } catch (error) {
      window.handleAxiosError(error);
      if (error.response.status === 401) {
        this.authorised = false;
      }
    }
  },
};
</script>
